import React from 'react'
import { Image, ImageSourcePropType, TouchableOpacity, View } from 'react-native'
import { ModalProps } from 'react-native-modal'

import { CommonModal } from '../CommonModal/commonModal'
import { Text } from '../text/text'
import { styles } from './styles'

export interface TeacherOptionModalProps extends Partial<ModalProps> {
  visible: boolean
  onClose: () => void
  unseatPlayer: () => void
  isEveryoneMute: boolean
  onMuteEveryone: () => void
  onUnmuteEveryone: () => void
}

const Option = (props: { handlePressAction: () => void; icon: ImageSourcePropType; label: string }) => {
  const { handlePressAction, icon, label } = props
  return (
    <TouchableOpacity
      onPress={handlePressAction}
      style={{ flexDirection: 'row', padding: 10, paddingLeft: 20, alignItems: 'center' }}
    >
      <View style={{ padding: 5 }}>
        <Image source={icon} style={{ width: 20, height: 20, resizeMode: 'contain' }} />
      </View>
      <Text allowFontScaling={false} tx={label} style={{ color: 'white', fontSize: 16, paddingHorizontal: 15 }} />
    </TouchableOpacity>
  )
}

export const TeacherOptionModal = (props: TeacherOptionModalProps) => {
  const { onClose, visible, unseatPlayer, isEveryoneMute, onMuteEveryone, onUnmuteEveryone, ...rest } = props

  const modalContent = () => {
    return (
      <View style={styles.modalInnerContainer}>
        <Option
          label={'teacherOptions.unseatPlayer'}
          icon={require('../../../assets/menu/BlockUser.png')}
          handlePressAction={unseatPlayer}
        />
        {isEveryoneMute ? (
          <Option
            label={'teacherOptions.unmuteAll'}
            icon={require('../../../assets/menu/microphone.png')}
            handlePressAction={onUnmuteEveryone}
          />
        ) : (
          <Option
            label={'teacherOptions.muteAll'}
            icon={require('../../../assets/menu/mute.png')}
            handlePressAction={onMuteEveryone}
          />
        )}
      </View>
    )
  }

  return (
    <CommonModal key={'OptionModal'} {...rest} visible={visible} showCloseButton={true} onClose={onClose}>
      {modalContent()}
    </CommonModal>
  )
}
